export default {
    contactList: [],
    contactListConditions: [],
}
